import React from 'react';

import UIStrings from '@/Utils/UIStrings';

interface CompanyDetailPointListProps {
    icon: React.ReactNode;
    label: string;
    value?: string | number | null;
}

const CompanyDetailPointList = ({ icon, label, value }: CompanyDetailPointListProps) => {
    return (
        <div className="text-muted-foreground flex w-full flex-row gap-1">
            {icon}
            <div className="flex w-full flex-col gap-1">
                <span className="text-xs">{label}</span>
                <span className="text-foreground text-xs">{value || UIStrings.NA}</span>
            </div>
        </div>
    );
};

export default CompanyDetailPointList;
